import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {appLink, parseOfferSlugToObject} from "@rw/cars_routes";

import {hitOfferClickEvent} from "../../../../tracking/common/hit_offer_view_event";

interface CarProps {
    id?: number;
    brand: string;
    model: string;
    year: number;
    mileage: number;
    price: number;
    image?: string;
    slug: string;
    listName?: string;
    /** 1-based position in the list for GA4 offer_click. */
    position?: number;
    onDeleteFav?: (id: number) => void;
}

const CarBoxContainer = styled.div`
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 16px;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: relative;
`;

const CarImage = styled.img`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
    transition: transform 0.3s ease-in-out;
`;
const carImageWrapper = css`
    position: relative;
    overflow: hidden;
    width: 100%;
    aspect-ratio: 4 / 3;
    margin-bottom: 16px;
    border-radius: 4px;
    background-color: #f0f0f0;
`;

const CarDetails = styled.div`
    color: #555;

    h3 {
        font-size: 1.2em;
        margin-bottom: 8px;
    }

    p {
        margin: 4px 0;
        font-size: 0.9em;
    }
`;
const boxLink = css`
    &:hover {
        text-decoration: none !important;
        img {
            transform: scale(1.1);
        }
    }
`;

export const CarBox: React.FC<CarProps> = ({brand, model, year, mileage, price, id, image, slug, listName, position, onDeleteFav}) => {
    const offerUrlParams = parseOfferSlugToObject(slug);
    const offerHref = appLink.fullOffer.detail.base(offerUrlParams);
    const brandLabel = brand === "mercedesbenz" ? "Mercedes-Benz" : brand;
    const offerName = `${brandLabel} ${model}`.trim();

    const onOfferClick = () => {
        if (!id) {
            return;
        }

        hitOfferClickEvent({
            offer_id: String(id),
            offer_name: offerName,
            offer_slug: slug,
            brand,
            make: brand,
            model,
            year: String(year),
            price,
            position,
            list_name: listName || "offer_card"
        });
    };

    return (
        <CarBoxContainer>
            <a
                className="offer-link"
                css={boxLink}
                href={offerHref}
                onClick={onOfferClick}
                data-offer-id={id}
                data-offer-make={brand}
                data-offer-model={model}
            >
                <div css={carImageWrapper}>{image && <CarImage src={image} alt={`${brand} ${model}`} />}</div>
                <CarDetails>
                    <h3>
                        {brandLabel} {model}
                    </h3>
                    {year != null && Number(year) > 0 && <p>Rok: {year}</p>}
                    <p>Przebieg: {mileage} km</p>
                    <p>Cena: {price} PLN</p>
                </CarDetails>
            </a>
            {onDeleteFav && id != null && (
                <span css={deleteStyle} onClick={() => onDeleteFav(id)}>
                    x
                </span>
            )}
        </CarBoxContainer>
    );
};

const deleteStyle = css`
    position: absolute;
    right: 12px;
    top: 5px;
    color: red;
    background: white;
    border-radius: 21px;
    padding: 6px 6px 8px 6px;
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    font-weight: bold;
    border: 1px solid white;
    transition: all 0.3s ease;

    &:hover {
        cursor: pointer;
        border: 1px solid red;
    }
`;
